import ApiBase from '../../../api-base'
import { ACTIVE_BASE_REST } from '../../../constants'

export default class FinancialTariffFurnitureAddon extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/tariff/furniture/addon'
    super(store, path)
  }
}
